import { render, staticRenderFns } from "./admissionTicket.vue?vue&type=template&id=29d6ee81&scoped=true&"
import script from "./admissionTicket.vue?vue&type=script&lang=js&"
export * from "./admissionTicket.vue?vue&type=script&lang=js&"
import style0 from "./admissionTicket.vue?vue&type=style&index=0&id=29d6ee81&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d6ee81",
  null
  
)

export default component.exports